














import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop } from 'vue-property-decorator';
import { IFormControl } from '@/entities/form.interface';
import { IListItem } from '@/entities/list-item.interface';

@Component({})
export default class CheckboxGroupComponent extends Vue {
  @Prop() public control: IFormControl;

  @Prop() public options: IListItem[];

  @Emit()
  public change($event) {
    // emit value to parent
  }
}
